import type { SVGProps } from 'react';

export const Add = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.25 12.75h-5a.799.799 0 0 1-.55-.2.798.798 0 0 1-.2-.55.71.71 0 0 1 .2-.525.748.748 0 0 1 .55-.225h5v-5a.71.71 0 0 1 .2-.525A.748.748 0 0 1 12 5.5c.217 0 .392.075.525.225.15.133.225.308.225.525v5h5c.217 0 .392.075.525.225.15.133.225.308.225.525 0 .217-.075.4-.225.55a.71.71 0 0 1-.525.2h-5v5c0 .217-.075.4-.225.55a.71.71 0 0 1-.525.2.798.798 0 0 1-.55-.2.798.798 0 0 1-.2-.55v-5Z" />
    </svg>
  );
};
